<template>
    <Modal @cancel="cancel">
        <div class="container-modale">
            <img class="close-icon" v-on:click="cancel" :src="closeIcon" alt="close" />
            <img class="img-communication cursor-pointer" :src="communicationsImagesLocation+communication.nomImage" alt="communication" @click='enSavoirPlus'/>
            <p class="texte">{{communication.texte}}</p>
            <div class="buttons">
                <Button class="button" :text="$t('home.modale.knowmore')" :onClick="this.enSavoirPlus" />
            </div>
            <div class="checkbox-container">
                <input class="checkbox" id="checkbox" type="checkbox" v-model="nePlusVoir">
                <label for="checkbox">{{ $t('home.modale.checkbox') }}</label>
                <ReglePastille cle="dashboard.communicationModale" />
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import { store } from '@/plugins/store';
import { HomeAction } from '../store/actions-types';
import { HOME } from '../store/mutation-types';
import Button from '@/components/ui-components/Button.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'HomePageModale',
    components: { Modal, Button, ReglePastille },
    data() {
        const nePlusVoir = false;
        return {
            nePlusVoir
        };
    },
    methods: {
        cancel(){
            if(this.nePlusVoir){
                store.dispatch(HomeAction.DONT_SHOW, this.communication?.id);
            } else {
                store.dispatch(HomeAction.SEEN, this.communication?.id);
            }
            store.commit(HOME.SET_HOMEPAGE_COMMUNICATION, null);
        },
        enSavoirPlus(){
            store.dispatch(HomeAction.KNOW_MORE, this.communication?.id);
            window.open(this.communication?.urlEnSavoirPlus);
        },
    },
    computed:{
        communication() {
            return store.state.homeState.communication;
        },
        communicationsImagesLocation(){
            return window.CONFIG.imagesCommunications;
        },
        closeIcon() {
            return require('@/assets/img/close-black.svg');
        },
    },
});
</script>

<style scoped>
.close-icon {
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
    z-index: 99;
}
.container-modale {
    max-width: 50vw;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 1px 5px rgba(0, 0, 0, 0.12);
    padding: 30px 30px 15px 30px;
}
.img-communication {
    height: 100%;
    width: 100%;
    object-fit: cover;
}
.texte {
    margin-top: 1vh;
}
.buttons {
    margin-top: 1vh;
    align-self: flex-end;
}
.button {
    margin-left: 1vw;
    background-color: var(--light-green);
    border: 0 solid;
    color: var(--white);
}
.checkbox-container {
    margin-top: 1vh;
    font-size: var(--font-size-medium);
}
.checkbox {
    width: 16px;
    height: 16px;
}
.cursor-pointer{
  cursor: pointer;
}
</style>
